var map = {
	"./black-bound-solid.png": 9406,
	"./black-dashboard-icon.png": 9828,
	"./black-discovery-icon.png": 7338,
	"./black-edit-pencil.png": 2990,
	"./black-eye.png": 323,
	"./black-farmer-icon.png": 6457,
	"./black-inventory-icon.png": 1060,
	"./black-logistics-icon.png": 4171,
	"./black-mill-icon.png": 2416,
	"./black-profit-input.png": 5383,
	"./black-purchase.png": 7643,
	"./black-settings-icon.png": 6283,
	"./black-tag-solid.png": 8902
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8597;